<p class="message">{{ message }}</p>

<div class="dashboard-list">
    <a [routerLink]="[clientCode, 'views', 'view', dashboard.id]" target="_blank" *ngFor="let dashboard of dashboards">
        {{ dashboard.name }} (ID = {{ dashboard.id }})
    </a>
</div>

<button class="ghost-btn" (click)="close()">OK</button>
